import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { useOffline } from "@/lib/net";
import { formatTRY } from "@/lib/format";
import { Field, sel, todayIso, AccLabel, accColor } from "@/lib/finance";

export default function ExpenseDialog({ accounts, onClose, onDone }) {
  const [cats, setCats] = useState([]);
  const [f, setF] = useState({ account_id: accounts.find((a) => a.type === "banka")?.id || accounts[0]?.id || "", amount: "", date: todayIso(), category: "", description: "", planned: false });
  const [busy, setBusy] = useState(false);
  const off = useOffline();
  const [idem] = useState(() => crypto.randomUUID());
  useEffect(() => { api.get("/finans/meta").then(({ data }) => { setCats(data.categories); setF((x) => ({ ...x, category: x.category || data.categories[0] })); }); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/finans/expenses", { ...f, amount: Number(f.amount) }, { headers: { "Idempotency-Key": idem } });
      toast.success(f.planned ? "Planlı ödeme eklendi" : "Gider kaydedildi");
      onDone();
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="expense-dialog">
        <DialogHeader><DialogTitle>Gider / Ödeme Girişi</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid grid-cols-2 gap-3">
          <Field label={<AccLabel text="Hesap" color={accColor(accounts, f.account_id)} />} className="col-span-2">
            <select className={`${sel} w-full`} value={f.account_id} onChange={set("account_id")} data-testid="expense-account">
              {accounts.map((a) => <option key={a.id} value={a.id}>{a.name} · {formatTRY(a.balance)}</option>)}
            </select>
          </Field>
          <Field label="Kategori">
            <select className={`${sel} w-full`} value={f.category} onChange={set("category")} data-testid="expense-category">{cats.map((c) => <option key={c} value={c}>{c}</option>)}</select>
          </Field>
          <Field label="Tutar (₺)"><Input type="number" step="0.01" min="0.01" required value={f.amount} onChange={set("amount")} data-testid="expense-amount" /></Field>
          <Field label={f.planned ? "Planlanan Ödeme Tarihi" : "Tarih"}><Input type="date" required value={f.date} onChange={set("date")} data-testid="expense-date" /></Field>
          <label className="flex items-end gap-2 text-[13px] text-slate-700 pb-2"><input type="checkbox" checked={f.planned} onChange={set("planned")} data-testid="expense-planned" />Planlı ödeme (bakiyeyi etkilemez)</label>
          <Field label="Açıklama" className="col-span-2"><Input required minLength={3} value={f.description} onChange={set("description")} data-testid="expense-description" /></Field>
          <DialogFooter className="col-span-2">
            <Button type="button" variant="outline" onClick={onClose} data-testid="expense-cancel">Vazgeç</Button>
            <Button type="submit" disabled={busy || off} className="bg-blue-600 hover:bg-blue-700" data-testid="expense-submit">{busy && <Loader2 className="h-4 w-4 animate-spin mr-1" />}Kaydet</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
